<div class="xp-column-header__label" mat-sort-header [disabled]="sortDisabled()">{{ heading() }}</div>
<div class="xp-column-header__filter" (click)="$event.stopPropagation()"><ng-content></ng-content></div>
